import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomNavbar from "../../../components/CustomNavbar";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getCompetenciesDesc,
  saveCompetencieDesc,
  editCompetencieDesc,
  deleteCompetenciesDesc,
} from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import { getCompetenciesType } from "../../../redux/descriptorsProfiles/CompetenciesType/actions";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";
import config from "../../../config";
import {
  getAreas as getAreasGD,
  getCarpetas,
  getSubNivelesSancionesDocs,
} from "../../../redux/gestorDocumental/actions";
import { getClassification } from "../../../redux/Classification/actions";
import { getBase64 } from "../../../components/gestorDocumental/GestorDocumental";
import toastr from "toastr";

const schema = Yup.object().shape({
  nombre: Yup.string().ensure().required("**Campo requerido"),
  descripcion: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  tipo_competencia: Yup.string().required("**Campo requerido"),
  clasificacion: Yup.string().required("**Campo requerido"),
  nombre_GD: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  descripcion_GD: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  subnivel1: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  subnivel2: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  archivo: Yup.mixed().when("isEdit", {
    is: false,
    then: Yup.mixed()
      .required("**Campo requerido")
      .test(
        "fileSize",
        "**El archivo es demasiado grande, es requerido un archivo menor o igual a 200 megabytes",
        (file) => (file ? !(file.size / 1024 > 200000) : false)
      ),
  }),
});

const CompetenciesDesc = (props) => {
  //* States
  const [show, setShow] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("");
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Competencia",
  });
  //* Redux
  const {
    loaderCompetenciesDesc,
    saveLoaderCompetenciesDesc,
    competenciesDesc,
    competenciesDescError,
    competenciesDescFormError,
  } = useSelector((store) => store.competenciesDesc);
  //* variables
  const dispatch = useDispatch();
  const pages = Math.ceil(
    (competenciesDesc ? competenciesDesc.count : 0) / limit
  );

  const { loading, competenciesTypes } = useSelector(
    (store) => store.competenciesType
  );

  const { descriptoresPerfiles, email } = config.gestorDocumental;

  const {
    loadingAreas,
    loadingCarpetas,
    loaderSubNiveles,
    carpetas,
    subNiveles,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);
  const areasGD = useSelector((store) => store.gestorDocumental.areas);

  const classification = useSelector(
    (store) => store.classification.classification
  );
  const classificationLoader = useSelector(
    (store) => store.classification.loading
  );

  const columns = [
    {
      Header: "Competencia",
      accessor: "nombre",
    },
    {
      id: "tipo_competencia",
      Header: "Tipo de competencia",
      Cell: (value) =>
        value.row.original.list_tipo_competencia &&
        value.row.original.list_tipo_competencia.length
          ? value.row.original.list_tipo_competencia[0].descripcion
          : null,
    },
    {
      id: "clasificacion",
      Header: "Clasificación",
      Cell: (value) =>
        value.row.original.list_clasificacion &&
        value.row.original.list_clasificacion.length > 0
          ? value.row.original.list_clasificacion[0].nombre
          : null,
    },
    {
      id: "fecha_creacion",
      Header: "Fecha de creación",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          {value.row.original.list_archivo &&
          value.row.original.list_archivo.length > 0 ? (
            <LinkDescargaListGD
              id={value.row.original.list_archivo[0].id}
              filters={{
                email: email,
                id: value.row.original.list_archivo[0].id_documento,
                llave: value.row.original.list_archivo[0].llave,
              }}
              origen={value.row.original.list_archivo[0].origen}
              cType={value.row.original.list_archivo[0].contentTypeGD}
            />
          ) : null}
        </div>
      ),
    },
  ];
  const filters = [
    { id: "nombre", desc: "Competencia" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];
  //* Method
  const _getCompetenciesDesc = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetenciesDesc({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    _getCompetenciesDesc();
    dispatch(getCompetenciesType({}));
    dispatch(getAreasGD());
    dispatch(getCarpetas());
    dispatch(getClassification({}, 2));
  }, []);

  useEffect(() => {
    if (areasGD && areasGD.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) =>
          item.descripcion.toLowerCase() ===
          descriptoresPerfiles.competencias.carpeta.toLowerCase()
      );
      if (oCarpeta) {
        dispatch(
          getSubNivelesSancionesDocs({
            areaid: parseInt(areasGD[0].id),
            ceid: parseInt(oCarpeta.id),
          })
        );
      }
    }
  }, [areasGD, carpetas]);

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetenciesDesc(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (values) => {
    try {
      let reqDoc = null;
      if (values.archivo) {
        const oCarpeta = carpetas.find(
          (item) =>
            item.descripcion.toLowerCase() ===
            descriptoresPerfiles.competencias.carpeta.toLowerCase()
        );
        const filebase64 = await getBase64(values.archivo);
        const fileName = values.archivo.name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");
        reqDoc = {
          id_area: parseInt(areasGD[0].id),
          id_carpeta_encabezado: parseInt(oCarpeta.id),
          subnivel1: values.subnivel1,
          subnivel2: values.subnivel2,
          medidas_disciplinarias: "",
          tipo_documento: descriptoresPerfiles.competencias.tipoDocumento,
          archivo: aFileBase[1],
          origen: fName + fExt,
          extension: fExt,
          contentTypeGD: `${aFileBase[0]},`,
          nombre: values.nombre_GD,
          descripcion: values.descripcion_GD,
        };
      }
      const req = {
        reqDoc: reqDoc,
        req: {
          nombre: values.nombre,
          descripcion: values.descripcion,
          tipo_competencia: values.tipo_competencia,
          clasificacion: values.clasificacion,
          nombre_gestor_documental: values.nombre_GD,
          descripcion_gestor_documental: values.descripcion_GD,
        },
      };
      if (!edit) {
        dispatch(saveCompetencieDesc(req, setShowFormModal));
      } else {
        req.id = editItem.id;
        req.req.archivo = editItem.archivo;
        if (req.reqDoc) {
          req.reqDoc.id = editItem.list_archivo[0].id;
        }
        dispatch(editCompetencieDesc(req, index, setShowFormModal));
      }
    } catch (ex) {
      toastr.info("Error al subir archivo");
      return;
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetenciesDesc(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCompetenciesDesc(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Competencias</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {competenciesDescError && (
            <Alert variant="danger" className="my-4">
              {competenciesDescError}
            </Alert>
          )}
          {loaderCompetenciesDesc || loadingCarpetas || loadingAreas ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : competenciesDesc && competenciesDesc.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={competenciesDesc.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={competenciesDesc.count}
                pages={pages}
                pagFunc={_getCompetenciesDesc}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Sin registros que mostrar.
            </Alert>
          )}
        </Container>
      </div>
      {/*  */}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            descripcion: edit ? editItem.descripcion : "",
            tipo_competencia: edit ? editItem.tipo_competencia : "",
            clasificacion: edit ? editItem.clasificacion : "",
            nombre_GD: edit ? editItem.nombre_gestor_documental : "",
            descripcion_GD: edit ? editItem.descripcion_gestor_documental : "",
            archivo: null,
            subnivel1: edit
              ? editItem.list_archivo && editItem.list_archivo.length > 0
                ? editItem.list_archivo[0].subnivel1
                : ""
              : "",
            subnivel2: edit
              ? editItem.list_archivo && editItem.list_archivo.length > 0
                ? editItem.list_archivo[0].subnivel2
                : ""
              : "",
            isEdit: edit,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            //isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar Competencias" : "Agregar Competencias"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {competenciesDescFormError &&
                typeof competenciesDescFormError !== "object" ? (
                  <Alert variant="danger" className="mt-4 mb-2">
                    {competenciesDescFormError}
                  </Alert>
                ) : null}
                {!!subNivelesError ? (
                  <Alert variant="danger" className="my-2">
                    <p>{!!subNivelesError && subNivelesError}</p>
                  </Alert>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre de la competencia"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {competenciesDescFormError &&
                    typeof competenciesDescFormError === "object" &&
                    competenciesDescFormError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {competenciesDescFormError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descripción
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      as="textarea"
                      name="descripcion"
                      required
                      value={values.descripcion} // 22
                      placeholder="Descripción de la competencia"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {competenciesDescFormError &&
                    typeof competenciesDescFormError === "object" &&
                    competenciesDescFormError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {competenciesDescFormError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de competencia
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loading ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="tipo_competencia"
                          className="rounded-pill"
                          disabled={loading}
                          required
                          value={values.tipo_competencia}
                          isInvalid={
                            touched.tipo_competencia &&
                            !!errors.tipo_competencia
                          }
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="" disabled selected>
                            Tipo de competencia
                          </option>
                          {competenciesTypes.length > 0
                            ? competenciesTypes.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.descripcion.toUpperCase()}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.tipo_competencia}
                        </Form.Control.Feedback>
                        {competenciesDescFormError &&
                        typeof competenciesDescFormError === "object" &&
                        competenciesDescFormError.tipo_competencia ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {competenciesDescFormError.tipo_competencia.map(
                              (item) => (
                                <li>{item}</li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </Col>
                      {loading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={classificationLoader ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="clasificacion"
                          className="rounded-pill"
                          disabled={edit && classificationLoader}
                          required
                          value={values.clasificacion}
                          isInvalid={
                            touched.clasificacion && !!errors.clasificacion
                          }
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="" disabled selected>
                            Clasificación
                          </option>
                          {classification
                            ? classification
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.nombre
                                      ? item.nombre.toUpperCase()
                                      : ""}
                                  </option>
                                ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.clasificacion}
                        </Form.Control.Feedback>
                        {competenciesDescFormError &&
                        typeof competenciesDescFormError === "object" &&
                        competenciesDescFormError.clasificacion ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {competenciesDescFormError.clasificacion.map(
                              (item) => (
                                <li>{item}</li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </Col>
                      {classificationLoader && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <hr />
                <p className="text-muted">Archivo</p>
                <hr />
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Módulo
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderSubNiveles ? "10" : "12"}>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="subnivel1"
                          className="rounded-pill"
                          value={values.subnivel1}
                          onChange={handleChange}
                          isInvalid={touched.subnivel1 && !!errors.subnivel1}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar módulo
                          </option>
                          {subNiveles && Array.isArray(subNiveles.module)
                            ? subNiveles.module.map((subnivel) => (
                                <option
                                  key={subnivel.id}
                                  value={subnivel.descripcion}
                                >
                                  {subnivel.descripcion}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.subnivel1}
                        </Form.Control.Feedback>
                        {competenciesDescFormError &&
                        typeof competenciesDescFormError === "object" &&
                        competenciesDescFormError.subnivel1 ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {competenciesDescFormError.subnivel1.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderSubNiveles && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderSubNiveles ? "10" : "12"}>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="subnivel2"
                          className="rounded-pill"
                          value={values.subnivel2}
                          onChange={handleChange}
                          isInvalid={touched.subnivel2 && !!errors.subnivel2}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar tipo de archivo
                          </option>
                          {subNiveles && Array.isArray(subNiveles.files)
                            ? subNiveles.files.map((subnivel) => (
                                <option
                                  key={subnivel.id}
                                  value={subnivel.descripcion}
                                >
                                  {subnivel.descripcion}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.subnivel2}
                        </Form.Control.Feedback>
                        {competenciesDescFormError &&
                        typeof competenciesDescFormError === "object" &&
                        competenciesDescFormError.subnivel2 ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {competenciesDescFormError.subnivel2.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderSubNiveles && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre del archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="nombre_GD"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre_GD}
                      placeholder="Nombre del archivo"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre_GD && !!errors.nombre_GD}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_GD}
                    </Form.Control.Feedback>
                    {competenciesDescFormError &&
                    typeof competenciesDescFormError === "object" &&
                    competenciesDescFormError.nombre_GD ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {competenciesDescFormError.nombre_GD.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descripción del archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      as="textarea"
                      name="descripcion_GD"
                      required
                      value={values.descripcion_GD} // 22
                      placeholder="Descripción del archivo"
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.descripcion_GD && !!errors.descripcion_GD
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion_GD}
                    </Form.Control.Feedback>
                    {competenciesDescFormError &&
                    typeof competenciesDescFormError === "object" &&
                    competenciesDescFormError.descripcion_GD ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {competenciesDescFormError.descripcion_GD.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.File
                      accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx"
                      className="mt-2 text-left position-relative"
                      name="archivo"
                      onChange={(e) =>
                        setFieldValue("archivo", e.currentTarget.files[0])
                      }
                      isInvalid={touched.archivo && !!errors.archivo}
                      feedback={errors.archivo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.archivo}
                    </Form.Control.Feedback>
                    {competenciesDescFormError &&
                    typeof competenciesDescFormError === "object" &&
                    competenciesDescFormError.archivo ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {competenciesDescFormError.archivo.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                {edit && editItem.list_archivo ? (
                  <>
                    <hr />
                    <Row>
                      <Col sm={3}>
                        <p className="text-muted">Documento actual</p>
                      </Col>
                      <Col sm={9}>
                        <LinkDescargaGD
                          id={editItem.list_archivo[0].id}
                          filters={{
                            email: email,
                            id: editItem.list_archivo[0].id_documento,
                            llave: editItem.list_archivo[0].llave,
                          }}
                          origen={editItem.list_archivo[0].origen}
                          cType={editItem.list_archivo[0].contentTypeGD}
                        />
                      </Col>
                    </Row>
                    <hr />
                  </>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoaderCompetenciesDesc}
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderCompetenciesDesc && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default CompetenciesDesc;
